module.exports = __webpack_public_path__ + "img/1.b70af3fe.svg";